const updates = [
  {
    date: '2026-07-31',
    title: '《逆流而上》大结局上线，全网播放量突破50亿',
    summary: '年度现象级都市情感剧迎来大结局，农民影视同步上线全集高清资源，引发全网追剧热潮。',
  },
  {
    date: '2026-07-29',
    title: '暑期档科幻大片《星辰彼岸》高清版独家上线',
    summary: '票房突破30亿的国产科幻巨制高清版正式登陆，视觉特效震撼，科幻迷不容错过。',
  },
  {
    date: '2026-07-27',
    title: '平台新增纪录片频道，首批上线200+部高分作品',
    summary: '涵盖自然、历史、科技、人文四大类别，BBC、央视等顶级制作方的高分纪录片免费观看。',
  },
  {
    date: '2026-07-25',
    title: '暑期追剧季活动开启，每日推荐热门剧集专题',
    summary: '暑假期间特别策划追剧专题，每日更新一批高分剧集推荐，涵盖悬疑、古装、都市等多种类型。',
  },
  {
    date: '2026-07-22',
    title: '动漫专区扩展升级，国漫日漫资源全面上新',
    summary: '动漫频道迎来大规模资源扩容，新增500+部动漫作品，热门新番同步更新不等待。',
  },
  {
    date: '2026-07-20',
    title: '网站播放体验优化，全站高清画质全面升级',
    summary: '技术团队完成播放系统升级，画质更清晰、加载更快速，全网用户均可享受升级后的观影体验。',
  },
  {
    date: '2026-07-18',
    title: '六月热播剧口碑排行榜公布，多部黑马剧集上榜',
    summary: '根据全站播放数据和用户反馈整理的口碑榜单出炉，多部小众佳作凭借过硬质量脱颖而出。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            实时追踪平台内容更新、功能升级与影视行业新鲜资讯
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-8">
            {updates.map((item) => (
              <article
                key={item.title}
                className="relative pl-10 md:pl-12 group cursor-pointer"
              >
                <div className="absolute left-2 md:left-3 top-1.5 w-4 h-4 md:w-5 md:h-5 rounded-full border-2 border-primary-500 bg-background-50 group-hover:bg-primary-500 transition-colors"></div>

                <div className="bg-white rounded-xl p-4 md:p-5 border border-background-200/70 group-hover:border-primary-200 transition-all">
                  <time className="text-xs text-foreground-500 mb-1.5 block">{item.date}</time>
                  <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.summary}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}